import { Collapse } from '@mui/material';
import { FC } from 'react';
import MaintenanceBanner from '../components/MaintenanceBanner';
import { useMaintenance } from '../hooks/use-maintenance';

const MaintenanceBannerContainer: FC = () => {
  const { state, handleClose } = useMaintenance();
  const { info, bannerOpen, bannerDismissed } = state;

  return (
    <Collapse in={bannerOpen && !bannerDismissed}>
      {info && <MaintenanceBanner info={info} onClose={handleClose} />}
    </Collapse>
  );
};

export default MaintenanceBannerContainer;
